<div class="p500-ui-modal__inner">
  <form class="c-form c-form--d" (ngSubmit)="submit()" [formGroup]="form">
    <div class="c-modal__head">
      <div class="row">
        <div>
          <div class="c-modal__close" (click)="close(); $event.preventDefault()">
            <p500-ui-icon name="controls-close"></p500-ui-icon>
          </div>
          <div class="c-modal__title col-12">{{ title }}</div>
          <div class="c-modal__subtitle col-12">{{ description }}</div>
        </div>
      </div>
    </div>

    <div class="p500-ui-modal__body">
      <p500-ui-cube-preloader [hidden]="!isLoading"></p500-ui-cube-preloader>
      <div class="p500-ui-modal__group" [hidden]="isLoading">
        <div class="head">
          <div class="p500-ui-modal__body-title"></div>
        </div>
        <div class="row">
          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-text-field
                [formControl]="nameControl"
                label="Name"
                i18n-label="@@common_name"
                [required]="true"
                (focusin)="inputFocused = true"
                (focusout)="inputFocused = false"
              ></p500-ui-text-field>
            </div>
          </div>

          <div class="c-form__section col-6" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-select-field
                [formControl]="formatControl"
                label="Format"
                i18n-label="@@common.format"
                [data]="formats"
                [required]="true"
              >
              </p500-ui-select-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="c-form__section col-12" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <p500-ui-text-field
                [formControl]="descriptionControl"
                label="Description"
                i18n-label="@@common.description"
                (focusin)="inputFocused = true"
                (focusout)="inputFocused = false"
              ></p500-ui-text-field>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="c-form__section col-12" gtdFieldWidth>
            <div class="c-form-field c-form-field--d">
              <gtd-calculator
                *ngIf="!isLoading"
                [initialFormula]="initialFormula"
                [metrics]="metrics"
                [formulaInvalid]="formulaInvalid"
                [inputFocused]="inputFocused"
                (formulaChange)="formulaChange($event)"
              ></gtd-calculator>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-modal__footer">
      <div class="d-flex">
        <div class="c-modal__action" (click)="close(); $event.preventDefault()">
          <button type="button" p500-ui-button stroked="true" i18n="@@common.cancel">Cancel</button>
        </div>
        <div class="c-modal__action">
          <button
            type="submit"
            p500-ui-button
            classIcon="p500-ui-icon-check"
            positionIcon="right"
            i18n="@@common.submit"
            [disabled]="form.invalid || isLoading || !formula?.length || formulaInvalid"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
